import { makePublishHelper, makeSubscribeHelper } from '../helpers-creators';

const schema = {};

export const commandOpen = makePublishHelper(
  'commandOpen',
  'wh.common.command.ui.header.deposit.open',
  schema,
);

export const onCommandOpen = makeSubscribeHelper(
  'onCommandOpen',
  'wh.common.command.ui.header.deposit.open',
  schema,
);
